import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/sample-management";

export const pagingSampleManagement = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getSampleManagementById = (sampleManagementId) => axios.get(API_PATH + "/get-by-id/" + sampleManagementId);

export const saveOrUpdateSampleManagement = sampleManagement => axios.post(API_PATH + "/save-or-update", sampleManagement);

export const deleteSampleManagement = sampleManagementId => axios.delete(API_PATH + '/mark-delete/' + sampleManagementId);
